<template>
  <div :class="`l28_tour_group ${is_final?'final':''}`">
    <h3>{{ name }}</h3>
    <ul>
      <template v-for="group in new_players">
        <li v-for="player in group" :key="player.role_id" :class="(player.if_rise || player.if_lucky_loser)&&!is_final?'nextround':''">
          <span class="player-rank-img" v-if="is_final && player.group_rank<=3">
            <img  :src="`${require(`@/assets/img/l28/tour-rank-${player.group_rank}.png`)}`"/>
          </span>
          <template v-else>
            <span class="player_rank" v-if="player.if_rise===0 && player.if_lucky_loser===0">{{player.group_rank===0?'':player.group_rank}}</span>
            <span :class="`player_tag ${player.if_lucky_loser===1?'luckyloser':''}`" v-else>{{player.if_lucky_loser===1?'LL':'Q'}}</span>
          </template>
          <img class="player-flag-img" :src="`https://ux.leihuo.netease.com/analyst/flag/${player.flag_country?player.flag_country.toUpperCase():''}.png`" alt="">{{player.short_name?player.short_name:player.role_name}}
          <span class="player-name" v-if="player.name!=='机器人' && player.name!=='外部玩家'">{{player.name}}</span>
          <span class="player-robot" v-if="player.name==='机器人'"></span>
          <span class="player-user" v-if="player.name==='外部玩家'"></span>
          <!-- <span :class="`player-type ${player.name==='机器人'?'robot':player.name==='外部玩家'?'outer':'inner'}`">{{ player.name!=='机器人' && player.name!=='外部玩家'?player.name:'' }}</span> -->
        </li>
      </template>
    </ul>
  </div>
</template>

<script>  
import { Tag } from 'ant-design-vue';
import Vue from 'vue';
Vue.use(Tag)
export default {
  name:'l28-lht-group',
  props: ['is_final', 'name', 'players'],
  methods: {
  },
  computed: {
    new_players() {
      const _players = []
      this.players.forEach(p=>{
        if(p) {
          _players.push(p)
        }
      })
      return _players
    }
  }
}
</script>

<style lang="less" scoped>
.l28_tour_group {
  background: #d3eafe;
  color: #33506f;
  font-weight: bold;
  width: 145px;
  // height: 219px;
  font-size: 12px;

  &.final {
    background:#ffcf60;
    h3 {
      background: #ffaf00;
      color: #a71700;
    }
    .player_rank {
      color: #33506c;
    }
    .player-name {
      color: #9a7011;
    }
  }
  h3 {
    text-align: center;
    margin: 0;
  }
  ul {
    margin: 0;
    padding: 0;
    li {
      position: relative;
      padding: 2px 3px;
      &.nextround {
        background: #79bbfe;
      }
    }
  }
  .player_rank {
    display: inline-block;
    width: 18px;
    height: 15px;
    color: #6a9dda;
    font-weight: bold;
    text-align: center;
  }
  .player_tag {
    display: inline-block;
    width: 16px;
    height: 15px;
    line-height: 13px;
    text-align: center;
    font-weight: bold;
    color: #fff9d6;
    background: #ff784f;
    border:1px solid #fff;
    border-radius: 3px;
    &.luckyloser {
      background: #ff9a50;
      letter-spacing: -3px;
      padding: 0 2px 0 0;
    }
  }
  .player-flag-img {
    width: 22px;
    height: 15px;
    border: 1px solid #ffb700;
    margin: 0 3px;
  }
  .player-rank-img {
    width: 24px;
    height: 15px;
    text-align: center;
    img {
      width: 18px;
      height: 15px;
      margin: 0 0 0 2px;
    }
  }
  .player-name {
    position: absolute;
    right: 2px;
    top: 0;
    line-height: 22px;
    color: #3c79b7;
    float: right;
  }
  .player-robot {
    position: absolute;
    right: 2px;
    top:1px;
    display: block;
    width: 18px;
    height: 18px;
    background: url(../../../assets/img/rbt.png) no-repeat;
    background-size: cover;
    opacity: 0.5;
  }
  .player-user {
    position: absolute;
    right: 2px;
    top: 1px;
    display: block;
    width: 18px;
    height: 18px;
    background: url(../../../assets/img/user.png) no-repeat;
    background-size: cover;
  }
  .player-type {
    display: block;
    font-size: 12px;
    border:1px solid #ddd;
    border-radius: 5px;
    padding: 0 5px;
    float: right;
  }
}
</style>